const AUTH = '[AUTH]';

export const SET_AUTH = `${AUTH} SET`;
export const LOGOUT = `${AUTH} LOGOUT`;

export const setAuth = data => ({
    type: SET_AUTH,
    payload: {
        data
    }
});

export const logout = () => ({
    type: LOGOUT
});
